module.exports = __webpack_public_path__ + "img/hn.35c4ba4b.svg";